<template lang="html">
     <div class="statistics_3_1">
          <div class="ttBar">
              <span>{{ prevMs.name }} - {{ nameTrans() }}</span>
              <span class="dateSpan">（{{ dateTime }}）</span>
          </div>
          <div class="tabArea">
               <div class="tabTtl">
                   <span class="ttText">流量分析表</span>
               </div>
               <table>
                    <tr class="tHead">
                        <td></td>
                        <td style="width:210px;">浏览次数（PV）</td>
                        <td style="width:210px;">独立访客（UV）</td>
                        <td style="width:210px;">IP访问量</td>
                        <td>播放时长</td>

                    </tr>
                    <tr v-for="term in testData">
                        <td>{{ term.tName }}</td>
                        <td>{{ term.pv }}</td>
                        <td>{{ term.uv }}</td>
                        <td>{{ term.ip }}</td>
                        <td>{{ term.pTime }}</td>

                    </tr>
               </table>
          </div>
          <div class="tabArea">
               <div class="tabTtl">
                   <span class="ttText">流量分析图</span>

                   <div class="timeArea">
                       <span>时间域：</span>
                       <el-select v-model="timeVal" size="small" @change="mapDatFor" placeholder="请选择">
                          <el-option
                            v-for="item in timeSelect"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.disabled">
                          </el-option>
                        </el-select>
                   </div>

              </div>
               <template>
                    <v-chart style="height:360px;width:100%;" :options="line"/>
               </template>

          </div>

     </div>
</template>

<script>
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import { statisticsDat,statisticsSum } from '@/api/statistics';
export default {
    components:{
        'v-chart':ECharts
    },
    data(){

         return{

             prevMs:{
                 code:'',
                 id:'',
                 name:''
             },

             dateTime:'',
             testData:[],

          // 时间域选择
             timeVal:1,
             timeSelect:[{
                value:1,
                label:'近一周'
             },{
                value:2,
                label:'近一月'
             }],

             line:{
                   tooltip: {
                      trigger: 'axis',
                      formatter: function(data){
                           var tipStr = '<div>'+ data[0].axisValue +'</div>';
                           for(var i = 0;i < data.length;i++){
                                var vName = '';
                                if(data[i].seriesName == '播放时长' || data[i].seriesName == '相对时长'){
                                    vName = vName + ' h';
                                }
                                var tempStr = '<div>' + data[i].marker +  data[i].seriesName + '：' + data[i].value + vName + '</div>';

                                tipStr = tipStr + tempStr;
                           };
                           return tipStr;
                      },
                   },
                   grid:{
                      left:'90',
                      right:'50'
                   },
                   legend: {
                      itemGap:15,
                      data:[{
                         name:'PV量',
                         icon:'roundRect'
                      },{
                        name:'UV量',
                        icon:'roundRect'
                      },{
                        name:'IP量',
                        icon:'roundRect'
                      },{
                        name:'播放时长',
                        icon:'roundRect'
                      },{
                        name:'相对时长',
                        icon:'roundRect'
                      }]
                   },
                   xAxis: {
                       name: '日期',
                       type: 'category',
                       data: [],
                       axisLabel:{
                           rotate:'0'
                       }
                   },
                   yAxis: {
                       type: 'value'
                   },
                   series: []
             },


         }
    },
    methods:{
         dateFormat:function(timeStr){
             let newTime = timeStr ? new Date(timeStr) : new Date();
             let y = newTime.getFullYear(),
                 m = newTime.getMonth() + 1,
                 d = newTime.getDate();

             if(m < 10){
                 m = '0' + m;
             }

             if(d < 10){
                 d = '0' + d;
             }

             return y + '-' + m + '-' + d;
         },

         tabFormate:function(res){
             let unFormate = res;
             this.testData = [];

             if(unFormate.pvList.length > 0){
                 for(var i = unFormate.pvList.length - 1;i > unFormate.pvList.length - 3;i--){
                      var temp = {};

                      temp.pv = unFormate.pvList[i];
                      temp.uv = unFormate.uvList[i];
                      temp.ip = unFormate.ipList[i];
                      temp.pTime = (unFormate.playTimeList[i]/3600).toFixed(2) + ' h';

                      if(i == unFormate.pvList.length - 1){
                          temp['tName'] = '今天';
                      }else if(i == unFormate.pvList.length - 2){
                          temp['tName'] = '昨天';
                      }

                      this.testData.push(temp);

                 }
             }

             statisticsSum({organizationId:this.prevMs.id,code:this.prevMs.code,latelyDay:7}).then(response => {
                  let unFormate = response.webSumDTO;
                  var stemp = {
                      tName:'近一周',
                      pv:parseInt(unFormate.pv),
                      uv:parseInt(unFormate.uv),
                      ip:parseInt(unFormate.ip),
                      pTime:(unFormate.playTime/3600).toFixed(2) + ' h'
                  }

                  this.testData.push(stemp);
             })
         },

         mapFormate:function(res){
              this.line.xAxis.data = res.dateList;
              this.line.series = [];

         //   pv
              var line1 = {
                  type:'line',
                  name:'PV量',
                  data:res.pvList
              };
              this.line.series.push(line1);

       //     uv
              var line2 = {
                  type:'line',
                  name:'UV量',
                  data:res.uvList
              };
              this.line.series.push(line2);

      //      ip
              var line3 = {
                  type:'line',
                  name:'IP量',
                  data:res.ipList
              };
              this.line.series.push(line3);

              var arrPlay = [];
              for(var i = 0;i < res.playTimeList.length;i++){
                  var transTmp = res.playTimeList[i]/3600;
                  arrPlay.push(transTmp.toFixed(2));
              }

      //      播放时长
              var line4 = {
                  type:'line',
                  name:'播放时长',
                  data:arrPlay
              };

              this.line.series.push(line4);

              var arrComplate = [];
              for(var i = 0;i < res.fullTimeList.length;i++){
                  var transTmp = res.fullTimeList[i]/3600;
                  arrComplate.push(transTmp.toFixed(2));
              }

         },

         ssPostAct:function(num){
             statisticsDat({organizationId:this.prevMs.id,code:this.prevMs.code,latelyDay:num}).then(response => {
                  this.tabFormate(response);
                  this.mapFormate(response);
             })
         },

         mapDatFor:function(){
             if(this.timeVal == 1){
                 this.ssPostAct(7);
                 this.line.xAxis.axisLabel.rotate = '0';
             }else if(this.timeVal == 2){
                 this.ssPostAct(30);
                 this.line.xAxis.axisLabel.rotate = '-45';
             }
         },

         nameTrans:function(){
             var nameMap = {
                 1:'中华民族音乐数据库',
                 3:'京剧绝版赏析数据库',
                 4:'中华戏曲老唱片数据库',
                 5:'中华曲艺老唱片数据库',
                 6:'丝绸之路上的民族音乐数据库'
             };
             return nameMap[this.$route.query.code];
         }
    },
    created:function(){
         var codeMap = {
             1:'LCP',
             3:'JBSX',
             4:'XQ',
             5:'QY',
             6:'SCZL'
         };

         this.prevMs.id = this.$route.query.anysId;
         this.prevMs.code = codeMap[this.$route.query.code];
         this.prevMs.name = this.$route.query.name;

         this.dateTime = this.dateFormat();
         this.ssPostAct(7);
    }
}
</script>

<style lang="scss">
      .statistics_3_1{
           padding: 6px 12px;
           .ttBar{
                padding: 9px 12px 15px;

                border-bottom: 1px solid #e8e8e8;
                span{
                    font-size: 15px;
                    color: #666666;
                }

                .dateSpan{
                   font-size: 14px;
                   font-weight: bold;
                }
           }

           .tabArea{
                margin-top: 30px;
                padding: 0px 12px;
                .tabTtl{
                     margin-top: 20px;
                    .timeArea{
                        font-size: 14px;
                        color: #666666;
                        margin-left: 24px;
                        margin-top: 20px;

                        .el-select{
                             width: 90px;
                        }
                    }
                    .ttText{
                      font-size: 15px;
                      font-weight: bold;
                    }
                }
                table{
                    width: 100%;
                    margin-top: 20px;
                    td{
                        position: relative;
                        border-collapse: collapse;
                        padding: 9px 12px;
                        border: 1px solid #efefef;
                        font-size: 14px;
                        text-align: center;
                    }

                    .tHead td{
                        background: #F8F8F8;
                    }
                }

                .echarts{
                    width: 100%;
                    height: 100%;
                }
           }
      }

</style>



// WEBPACK FOOTER //
// flows.vue?183156d4